import { Outlet } from "react-router-dom";
import { StoreHeader } from "./StoreHeader";
import { StoreFooter } from "./StoreFooter";
import { KycModal } from "./KycModal";

export function StoreLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-[#F1F3F6] text-zinc-900">
      <StoreHeader />
      <main className="flex-1"><Outlet /></main>
      <StoreFooter />
      <KycModal />
    </div>
  );
}
